export default __webpack_public_path__ + "static/media/phot-line-5-2.2b87e21e.png";